import styled from '@emotion/styled';

export const HistorySection = styled.div`
  position: relative;

  .slick-slider {
    .slick-prev {
      left: 50%;
      margin-left: 490px;
      top: -100px;
    }
    .slick-next {
      left: 50%;
      margin-left: 560px;
      top: -100px;
    }
    .slick-slide {
      opacity: 0.25;
      &.slick-active {
        opacity: 1;
      }
    }
  }

  .history-content {
    border-top: 3px solid ${(props:any) => props.theme.colors.b.gr};
  }

  @media (max-width: ${(props:any) => props.theme.breakpoints.sm}) {
    .slick-slider {
      .slick-prev {
        left: auto;
        right: 60px;
        top: -160px;
      }
      .slick-next {
        left: auto;
        right: 0;
        top: -160px;
      }
    }
  }
`;


export const ContactSection = styled.div`
  em {
    color: ${(props:any) => props.theme.colors.b.gr};
  }
`
